import { z } from "zod";

export const taskAction = z.enum([
  "call",
  "follow_up",
  "phone_follow_up",
  "sms_follow_up",
  "send_cv",
  "send_sms",
  "send_email",
  "reference_check",
  "qualify",
  "request_documents",
  "visit",
  "proposal_follow_up",
  "available",
]);
export type TaskAction = z.infer<typeof taskAction>;
